"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Inclusion: ()=>Inclusion
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Inclusion_variants_cjs_namespaceObject = require("./Inclusion.variants.cjs");
const Inclusion = ({ icon, labelNode, type = 'included', size = 'sm', actionNode, fillNone = false, ...props })=>{
    const { inclusionSlot, textSlot, iconSlot, inclusionIconSlot } = (0, external_Inclusion_variants_cjs_namespaceObject.inclusionVariants)({
        ...props,
        fillNone,
        size
    });
    const iconSize = 'sm' === size ? '16' : '20';
    const inclusionIconSize = 'sm' === size ? '8' : '10';
    const iconNode = icon ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex items-end",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                className: inclusionIconSlot({
                    type
                }),
                iconName: icon,
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                className: iconSlot({
                    type
                }),
                iconName: getIconName(type, false),
                size: inclusionIconSize
            })
        ]
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
        className: iconSlot({
            type
        }),
        iconName: icon ?? getIconName(type, true),
        size: iconSize
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: inclusionSlot(),
        "aria-label": type,
        children: [
            iconNode,
            labelNode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: textSlot({
                    type
                }),
                children: labelNode
            }),
            actionNode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                children: actionNode
            })
        ]
    });
};
function getIconName(inclusionType, isDefaultIcon) {
    if ('included' === inclusionType) return isDefaultIcon ? 'check' : 'check_circle';
    if ('excluded' === inclusionType) return isDefaultIcon ? 'close' : 'cancel';
    return isDefaultIcon ? 'attach_money' : 'paid';
}
exports.Inclusion = __webpack_exports__.Inclusion;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Inclusion"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
